import { TYPE_BOOLEAN } from './input-types';

export const id = 'pickList';
export const apiKey = 'IsPickListPrinted';
export const type = TYPE_BOOLEAN;

export const pickList = {
  id,
  apiKey,
  type,
};
